import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativePortionsSEP: typeof valueTypeRenderers.chillCumulativePortionsSEP = {
  label: () => unitConverter.chillCumulativePortionsSEP().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativePortionsSEP().title(),
      render: (n) => unitConverter.chillCumulativePortionsSEP(n).valueAsString(),
    }),
}
